import React, { useEffect, useState } from "react";
import { Box, CircularProgress, Typography } from "@mui/material";

const CircularProgressComponent = (props) => {
  const [circleColor, setCircleColor] = useState("success");
  const { value, size, thickness, variant } = props;

  useEffect(() => {
    if (value >= 0 && value <= 30) {
      setCircleColor("error");
    } else if (value > 30 && value <= 60) {
      setCircleColor("warning");
    } else if (value > 60 && value <= 100) {
      setCircleColor("success");
    }
  }, [value]);

  return (
    <Box sx={{ position: "relative", display: "inline-flex" }}>
      <CircularProgress
        value={value === 0 ? 100 : value}
        size={size}
        thickness={thickness}
        color={circleColor}
        variant={variant}
      />
      <Box
        sx={{
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          position: "absolute",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}>
        <Typography variant="p" component="div" color="text.secondary">
          {`${Math.round(value)}%`}
        </Typography>
      </Box>
    </Box>
  );
};

export default CircularProgressComponent;
